const header = {
	ui: {
		isSearchOpen: false,
		isSubmenuOpen: false,
		isMenuMobileOpen: false,
		searchTimer: null
	},

	init: function() {
		this.bindUI();
		this.bindEvents();
	},

	bindUI: function bindUI() {
		this.ui.$window = $(window);
		this.ui.$document = $(document);
		this.ui.$scrollToDisable = $("html,body");

		this.ui.$headerOverlay = $(".js-header__overlay");
		this.ui.$headerClose = $(".js-header-close");

		this.ui.$menuToggle = $(".js-toggle-menu");
		this.ui.$menuContainer = $(".js-menu-container");
		this.ui.$menuNav = $(".js-menu-nav");
		this.ui.$headerOpenSubmenu = $(".js-open-header__submenu");
		this.ui.$headerSubmenu  = $(".js-header__submenu");
		this.ui.$headerSubmenuClose  = $(".js-close-header__submenu");

		this.ui.$headerSearch = $(".js-headerSearch");
		this.ui.$headerSearchOverlay = $(".js-headerSearch__overlay");
		this.ui.$headerSearchToggle  = $(".js-header-search-toggle");
		this.ui.$headerSearch__close = $(".js-headerSearch__close");

		this.ui.$headerSearch__form  = $(".js-headerSearch__form");
		this.ui.$headerSearch__input  = $(".js-headerSearch__input");
		this.ui.$headerSearch__result = $(".js-headerSearch__result");

	// login header popin
		this.ui.$openHeaderLogin = $(".js-open-header__login");
		this.ui.$headerLogin = $(".js-header__login");
	},

	bindEvents: function bindEvents() {
		// this.ui.$window.on('scroll', this.menuOnScroll.bind(this));
		
		this.ui.$menuToggle.on('click', this.toggleMenuMobile.bind(this));
		this.ui.$headerOpenSubmenu.on('click', this.toggleSubmenu.bind(this));
		// $("body").on('click', this.closeSubmenu.bind(this));
		this.ui.$headerClose.on('click', this.closeSubmenu.bind(this));
		this.ui.$menuNav.on('close:menu', this.closeSubmenu.bind(this));
		// this.ui.$headerOverlay.on('click', this.closeSubmenu.bind(this));
		this.ui.$headerSubmenuClose.on('click', this.closeSubmenuParent.bind(this));

		this.ui.$headerSearchToggle.on('click', this.toggleSearch.bind(this));
		this.ui.$headerSearchOverlay.on('click', this.closeSearch.bind(this));
		this.ui.$headerSearch__close.on('click', this.closeSearch.bind(this));

		this.ui.$headerSearch__input.on('keyup', this.autocompleteSearch.bind(this));


		this.ui.$openHeaderLogin.on('click', this.toggleHeaderLogin.bind(this));
		this.ui.$headerLogin.on('click', function(e){
			if(!$(e.target).hasClass("js-display-popin")){
				e.stopPropagation();
			}
		});
		$("body").on('click', this.closeHeaderLogin.bind(this));
	},

	closeHeaderLogin: function(e) {
		this.ui.$headerLogin.addClass("js-hide");
		this.ui.$openHeaderLogin.removeClass("active");
	},

	toggleHeaderLogin: function(e) {
		e.preventDefault();
		e.stopPropagation();
		this.ui.$openHeaderLogin.toggleClass("active");
		this.ui.$headerLogin.toggleClass("js-hide");
		this.closeSubmenu();
	},

	autocompleteSearch: function(e) {
		let that = this
		e.preventDefault();
		if(this.ui.searchTimer){
			clearTimeout(this.ui.searchTimer);
		}
		this.ui.searchTimer = setTimeout(()=>{
			// if(this.ui.$headerSearch__input.val() > 2){
				var $form = that.ui.$headerSearch__form
				,	ajaxTargetUrl = $form.attr("data-autocomplete")
				,	serializedArrayForm = $form.serializeArray();
				console.log(serializedArrayForm);
				// generate ajax params from form
					var JSONparams = {}
					for (var i = 0; i < serializedArrayForm.length; i++) {
						JSONparams[serializedArrayForm[i].name] = serializedArrayForm[i].value;
					}
			
				// maj URL with form params (for GET form)
				// 	let newUrl = "?";
				// 	for (var i = 0; i < serializedArrayForm.length; i++) {
				// 		if(i!=0){
				// 			newUrl += "&";
				// 		}
				// 		newUrl += serializedArrayForm[i].name+"="+serializedArrayForm[i].value;
				// 	}
				// 	if(history && history.pushState){//on vérifie si le navigateur supporte la navigation par historique
				// 		history.pushState({page: newUrl}, newUrl, newUrl);//on écrit dans l'historique, on modifie l'url
				// 	}
			
				that.ui.lock = true;
				$("html").addClass("loading");
				that.ui.$headerSearch__result.addClass("loading");
				that.ui.$headerSearch__result.removeClass("js-hide");
				// post or get
				$.get(
					ajaxTargetUrl,
					JSONparams,
					// or 
					// {
					// 	'param1' : 'param1Value',
					// 	'param2' : 'param2Value',
					// },
					function(response){}
				).done(function(response) {
					that.ui.$headerSearch__result.html(response);
				})
				.fail(function(response) {
					$form.addClass("has-error")
				})
				.always(function(response) {
					$("html").removeClass("loading");
					that.ui.$headerSearch__result.removeClass("loading");
					that.ui.lock = false;
				});
			// }
		}, 500);
	},
	handleScroll(){
		if(this.ui.isSearchOpen || this.ui.isSubmenuOpen || this.ui.isMenuMobileOpen){
			this.ui.$scrollToDisable.addClass("disable-scroll");
		}else{
			this.ui.$scrollToDisable.removeClass("disable-scroll");
		}
	},
	toggleSearch: function(e) {
		e.preventDefault();
		e.stopPropagation();

		this.closeSubmenu();

		let $this = $(e.target);
		this.ui.$headerSearch.toggleClass("open");
		this.ui.$headerSearchOverlay.toggleClass("open");

		if(this.ui.$headerSearch.hasClass("open")){
			this.ui.$headerSearch__input.focus();
			this.ui.isSearchOpen = true;
		}else{
			this.ui.isSearchOpen = false;
		}
		this.handleScroll();
	},
	
	closeSearch: function(e) {
		this.ui.$headerSearch.removeClass("open");
		this.ui.$headerSearchOverlay.removeClass("open");
		this.ui.isSearchOpen = false;
		this.handleScroll();
	},

	// menuOnScroll: function(e) {
	// 	let self = this;
	// 	let $this = $(e.target);
		
	// 	if($this.scrollTop() > 50 && !this.ui.$header.hasClass("header--smaller")) {
	// 		$(".js-header").addClass("header--smaller");
	// 	}
	// 	if($this.scrollTop() === 0 && this.ui.$header.hasClass("header--smaller")) {
	// 		$(".js-header").removeClass("header--smaller");
	// 	}
	// },

	toggleSubmenu: function(e) {
		e.preventDefault();
		e.stopPropagation();
		let $this = $(e.target);
		let $submenuTarget = $($this.attr("data-target"));
		let $siblings = $($submenuTarget.attr("data-siblings"));
		let $children = $($submenuTarget.attr("data-children"));
		$this.parent().siblings().find(".js-open-header__submenu").removeClass("active");
		if($submenuTarget.hasClass("open")){
			$this.removeClass("active");
			$submenuTarget.removeClass("open");
			$children.removeClass("open").find(".js-open-header__submenu").removeClass("active");
			$siblings.removeClass("open").find(".js-open-header__submenu").removeClass("active");
			if($(".js-header__submenu.open").length == 0){
				this.ui.$headerOverlay.removeClass("open");
				this.ui.isSubmenuOpen = false;
			}
		}else{
			$siblings.removeClass("open").find(".js-open-header__submenu").removeClass("active");
			$children.removeClass("open").find(".js-open-header__submenu").removeClass("active");
			$this.addClass("active");
			$submenuTarget.addClass("open");
			this.ui.$headerOverlay.addClass("open");
			this.ui.isSubmenuOpen = true;
		}
		this.closeHeaderLogin();
		this.closeSearch();
		this.handleScroll();
	},
	closeSubmenu: function() {
		this.ui.$headerSubmenu.removeClass("open");
		this.ui.$headerOverlay.removeClass("open");
		this.ui.$headerOpenSubmenu.removeClass("active");
		this.ui.isSubmenuOpen = false;
		this.handleScroll();
	},
	closeSubmenuParent: function(e) {
		let $this = $(e.target);
		let $currentSubMenu = $this.closest(".js-header__submenu")
		$currentSubMenu.removeClass("open");
		$currentSubMenu.parent().find(".js-open-header__submenu").removeClass("active");
		this.ui.$headerOverlay.removeClass("open");
	},
	closeMenuMobile: function(e) {
		this.ui.$scrollToDisable.removeClass("disable-scroll");
		this.ui.$menuToggle.removeClass("active");
		this.ui.$menuContainer.removeClass("active");
		this.ui.$menuNav.removeClass("active");
		this.ui.isMenuMobileOpen = false;
	},
	openMenuMobile: function(e) {
		this.ui.$scrollToDisable.addClass("disable-scroll");
		this.ui.$menuToggle.addClass("active");
		this.ui.$menuContainer.addClass("active");
		this.ui.$menuNav.addClass("active");
		this.ui.isMenuMobileOpen = true;
	},
	toggleMenuMobile: function(e) {
		if(this.ui.$menuToggle.hasClass("active")){
			this.closeMenuMobile();
		} else {
			this.openMenuMobile();
		}
		this.closeSearch();
		this.closeSubmenu();
		this.handleScroll();
	}

};

module.exports = header;
